import { useState, useEffect } from 'react';

/**
 * Custom hook to fetch and manage user activities
 * @returns {Object} Object containing activities array and loading state
 */
export const useActivity = () => {
      const [activities, setActivities] = useState([]);
      const [loading, setLoading] = useState(true);

      useEffect(() => {
            const fetchActivities = async () => {
                  try {
                        // Here you would typically fetch activities from your API
                        // Example structure:
                        const mockActivities = [
                              {
                                    id: 1,
                                    type: 'exercise',
                                    description: 'Morning jog',
                                    timestamp: new Date(),
                                    duration: '30 minutes'
                              },
                              {
                                    id: 2,
                                    type: 'social',
                                    description: 'Coffee with friends',
                                    timestamp: new Date(),
                                    participants: ['John', 'Sarah']
                              }
                              // ... more activities
                        ];

                        setActivities(mockActivities);
                  } catch (error) {
                        console.error('Error fetching activities:', error);
                  } finally {
                        setLoading(false);
                  }
            };

            fetchActivities();
      }, []);

      return {
            activities,
            loading
      };
}; 